export default "__VITE_ASSET__Bagfcr5___"